import React from "react";
import classes from "./History.module.css";
import { Uppercase } from "../../../../Utility";

const History = ({ historyLocations = [], requestDataForLocation }) => {
  if (historyLocations.length === 0) return null;

  return (
    <div data-tut="history">
      <div className={classes.Container}>
        {historyLocations.map((item, index) => (
          <button
            key={index}
            onClick={() => requestDataForLocation(item, "History")}
            className={classes.historyItem}
          >
            {Uppercase(`${item.location}, ${item.state}`)}
          </button>
        ))}
      </div>
    </div>
  );
};

export default History;